(() => {
  const root = document.querySelector('[data-ledup-tracker]');
  if (!root || document.documentElement.dataset.ledupTrackingLoaded) return;
  document.documentElement.dataset.ledupTrackingLoaded = 'true';
  const pendingKey = 'ledup_contact_pending';
  const isPreview = root.dataset.preview === 'true';
  let ready = false;
  let privacyLoading = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const context = () => ({page_type: root.dataset.pageType, page_path: root.dataset.pagePath, is_preview: isPreview});
  const publish = (name, extra = {}) => {
    if (!ready || !allowed()) return;
    const payload = {...context(), ...extra};
    try {
      const result = window.Shopify?.analytics?.publish(`flagprint:${name}`, payload);
      Promise.resolve(result).catch(() => {});
      root.dataset.lastEvent = name;
    } catch (_) {}
  };
  const checkSuccess = () => {
    if (!ready || !allowed() || !document.querySelector('[data-ledup-form-success]')) return;
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending || Date.now() - pending.time > 3600000 || pending.path !== root.dataset.pagePath) return;
      sessionStorage.removeItem(pendingKey);
      publish('contact_form_succeeded', {contact_method:'form',contact_purpose:'consultation'});
    } catch (_) {}
  };
  const setupPrivacy = () => {
    if (window.Shopify?.customerPrivacy) {
      ready = true;
      root.dataset.trackingState = allowed() ? 'ready' : 'consent-required';
      checkSuccess();
    } else if (!privacyLoading && window.Shopify?.loadFeatures) {
      privacyLoading = true;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        privacyLoading = false;
        if (!error) setupPrivacy();
        else root.dataset.trackingState = 'privacy-unavailable';
      });
    }
  };
  document.addEventListener('visitorConsentCollected', setupPrivacy);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button > 0) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const purpose = (link.dataset.ledupContactPurpose === 'reorder' || /[?&]subject=LEDUP(?:%20|\+)Nachbestellung(?:&|$)/i.test(href)) ? 'reorder' : 'consultation';
    if (/^mailto:/i.test(href)) publish('contact_email_clicked', {contact_method:'email',contact_purpose:purpose});
    else if (/^tel:/i.test(href)) publish('contact_phone_clicked', {contact_method:'phone',contact_purpose:'consultation'});
    else {
      try {
        const target = new URL(href, location.origin);
        if (['flagprint.ch','www.flagprint.ch'].includes(target.hostname)) publish('flagprint_clicked', {contact_method:'website',contact_purpose:'information'});
      } catch (_) {}
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-ledup-contact-form]') || !ready || !allowed()) return;
    try {sessionStorage.setItem(pendingKey,JSON.stringify({path:root.dataset.pagePath,time:Date.now()}));} catch (_) {}
  });
  setupPrivacy();
  window.addEventListener('load', setupPrivacy, {once:true});
})();
